<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  @if(remainingTime() > 0) {
  <div data-qa="test-resend-code-label" class="f-size-xs f-color-regular">
    {{ t('resendCodeMessage', { timeToResend: remainingTime() | number : '2.0' }) }}
  </div>
  } @else {
  <span class="resend-code f-size-xs" (click)="resendCode()" data-qa="test-resend-code-button">{{ t('resendCode') }}</span> }
</ng-container>
